"use strict";
// (C) 2021-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectIsSectionInsertedByPlugin = exports.selectSectionModification = exports.selectWidgetsModification = exports.selectWidgetsOverlayState = exports.selectWidgetsOverlay = exports.selectDraggingWidgetTarget = exports.selectDraggingWidgetSource = exports.selectInvalidUrlDrillParameterDrillLocalIdsByWidgetRef = exports.selectInvalidUrlDrillParameterWidgetWarnings = exports.selectInvalidUrlDrillParameterWidgetRefs = exports.selectInvalidDrillWidgetRefs = exports.selectActiveSectionIndex = exports.selectIsDraggingWidget = exports.selectSelectedFilterIndex = exports.selectIsFilterAttributeSelectionOpen = exports.selectIsWidgetLoadingAdditionalDataByWidgetRef = exports.selectInsightListLastUpdateRequested = exports.selectWidgetDateDatasetAutoSelect = exports.selectConfigurationPanelOpened = exports.selectSelectedWidgetRef = exports.selectMenuButtonItemsVisibility = exports.selectIsKpiAlertHighlightedByWidgetRef = exports.selectIsKpiAlertOpenedByWidgetRef = exports.selectFilterBarExpanded = exports.selectKpiDeleteDialogWidgetCoordinates = exports.selectIsCancelEditModeDialogOpen = exports.selectIsKpiDeleteDialogOpen = exports.selectIsDeleteDialogOpen = exports.selectIsShareDialogOpen = exports.selectIsSaveAsDialogOpen = exports.selectIsScheduleEmailManagementDialogOpen = exports.selectScheduleEmailDialogDefaultAttachment = exports.selectIsScheduleEmailDialogOpen = void 0;
var tslib_1 = require("tslib");
var toolkit_1 = require("@reduxjs/toolkit");
var sdk_model_1 = require("@gooddata/sdk-model");
var union_1 = tslib_1.__importDefault(require("lodash/union"));
var filter_1 = tslib_1.__importDefault(require("lodash/filter"));
var layoutSelectors_1 = require("../layout/layoutSelectors");
var selectors_1 = require("../_infra/selectors");
var objRefMap_1 = require("../../../_staging/metadata/objRefMap");
var selectSelf = toolkit_1.createSelector(function (state) { return state; }, function (state) { return state.ui; });
/**
 * @alpha
 */
exports.selectIsScheduleEmailDialogOpen = toolkit_1.createSelector(selectSelf, function (state) { return state.scheduleEmailDialog.open; });
/**
 * @alpha
 */
exports.selectScheduleEmailDialogDefaultAttachment = toolkit_1.createSelector(selectSelf, function (state) { var _a; return (_a = state.scheduleEmailDialog.defaultAttachmentRef) !== null && _a !== void 0 ? _a : undefined; });
/**
 * @alpha
 */
exports.selectIsScheduleEmailManagementDialogOpen = toolkit_1.createSelector(selectSelf, function (state) { return state.scheduleEmailManagementDialog.open; });
/**
 * @alpha
 */
exports.selectIsSaveAsDialogOpen = toolkit_1.createSelector(selectSelf, function (state) { return state.saveAsDialog.open; });
/**
 * @alpha
 */
exports.selectIsShareDialogOpen = toolkit_1.createSelector(selectSelf, function (state) { return state.shareDialog.open; });
/**
 * @internal
 */
exports.selectIsDeleteDialogOpen = toolkit_1.createSelector(selectSelf, function (state) { return state.deleteDialog.open; });
/**
 * @internal
 */
exports.selectIsKpiDeleteDialogOpen = toolkit_1.createSelector(selectSelf, function (state) { return !!state.kpiDeleteDialog.widgetCoordinates; });
/**
 * @internal
 */
exports.selectIsCancelEditModeDialogOpen = toolkit_1.createSelector(selectSelf, function (state) { return !!state.cancelEditModeDialog.open; });
/**
 * @internal
 */
exports.selectKpiDeleteDialogWidgetCoordinates = toolkit_1.createSelector(selectSelf, function (state) { return state.kpiDeleteDialog.widgetCoordinates; });
/**
 * @alpha
 */
exports.selectFilterBarExpanded = toolkit_1.createSelector(selectSelf, function (state) { return state.filterBar.expanded; });
var selectHighlightedKpiWidgetRef = toolkit_1.createSelector(selectSelf, function (state) { return state.kpiAlerts.highlightedWidgetRef; });
var selectOpenedKpiWidgetRef = toolkit_1.createSelector(selectSelf, function (state) { var _a; return (_a = state.kpiAlerts.openedWidgetRef) !== null && _a !== void 0 ? _a : undefined; });
/**
 * @alpha
 */
exports.selectIsKpiAlertOpenedByWidgetRef = selectors_1.createMemoizedSelector(function (ref) {
    return toolkit_1.createSelector(layoutSelectors_1.selectWidgetsMap, selectOpenedKpiWidgetRef, function (widgets, openedWidgetRef) {
        if (!ref) {
            return false;
        }
        var openedWidget = openedWidgetRef && widgets.get(openedWidgetRef);
        if (!openedWidget) {
            return false;
        }
        var targetWidget = widgets.get(ref);
        if (!targetWidget) {
            return false;
        }
        return targetWidget.identifier === openedWidget.identifier;
    });
});
/**
 * @alpha
 */
exports.selectIsKpiAlertHighlightedByWidgetRef = selectors_1.createMemoizedSelector(function (ref) {
    return toolkit_1.createSelector(layoutSelectors_1.selectWidgetsMap, selectHighlightedKpiWidgetRef, function (widgets, highlightedWidgetRef) {
        if (!ref) {
            return false;
        }
        var highlightedWidget = highlightedWidgetRef && widgets.get(highlightedWidgetRef);
        if (!highlightedWidget) {
            return false;
        }
        var targetWidget = widgets.get(ref);
        if (!targetWidget) {
            return false;
        }
        return targetWidget.identifier === highlightedWidget.identifier;
    });
});
/**
 * @alpha
 */
exports.selectMenuButtonItemsVisibility = toolkit_1.createSelector(selectSelf, function (state) { var _a; return (_a = state.menuButton.itemsVisibility) !== null && _a !== void 0 ? _a : {}; });
/**
 * @internal
 */
exports.selectSelectedWidgetRef = toolkit_1.createSelector(selectSelf, function (state) { return state.selectedWidgetRef; });
/**
 * @internal
 */
exports.selectConfigurationPanelOpened = toolkit_1.createSelector(selectSelf, function (state) { return state.configurationPanelOpened; });
/**
 * @internal
 */
exports.selectWidgetDateDatasetAutoSelect = toolkit_1.createSelector(selectSelf, function (state) { return state.widgetDateDatasetAutoSelect; });
/**
 * @internal
 */
exports.selectInsightListLastUpdateRequested = toolkit_1.createSelector(selectSelf, function (state) { return state.insightListLastUpdateRequested; });
var selectWidgetsLoadingAdditionalData = toolkit_1.createSelector(selectSelf, function (state) { return state.widgetsLoadingAdditionalData; });
/**
 * @internal
 */
exports.selectIsWidgetLoadingAdditionalDataByWidgetRef = selectors_1.createMemoizedSelector(function (ref) {
    return toolkit_1.createSelector(selectWidgetsLoadingAdditionalData, function (widgetsLoading) {
        return widgetsLoading.some(function (loadingRef) { return sdk_model_1.areObjRefsEqual(loadingRef, ref); });
    });
});
/**
 * @alpha
 */
exports.selectIsFilterAttributeSelectionOpen = toolkit_1.createSelector(selectSelf, function (state) { return state.filterAttributeSelectionOpen; });
/**
 * @alpha
 */
exports.selectSelectedFilterIndex = toolkit_1.createSelector(selectSelf, function (state) { return state.selectedFilterIndex; });
/**
 * @internal
 */
exports.selectIsDraggingWidget = toolkit_1.createSelector(selectSelf, function (state) { return state.draggingWidgetSource !== undefined; });
/**
 * @internal
 */
exports.selectActiveSectionIndex = toolkit_1.createSelector(selectSelf, function (state) { return state.activeSectionIndex; });
/**
 * @internal
 */
exports.selectInvalidDrillWidgetRefs = toolkit_1.createSelector(selectSelf, function (state) { return state.drillValidationMessages.invalidDrillWidgetRefs; });
var selectInvalidCustomUrlDrillParameterWidgets = toolkit_1.createSelector(selectSelf, function (state) { return state.drillValidationMessages.invalidCustomUrlDrillParameterWidgets; });
/**
 * @internal
 */
exports.selectInvalidUrlDrillParameterWidgetRefs = toolkit_1.createSelector(selectInvalidCustomUrlDrillParameterWidgets, function (invalidCustomUrlDrillParameterWidgets) { return invalidCustomUrlDrillParameterWidgets.map(function (i) { return i.widgetRef; }); });
/**
 * @internal
 */
exports.selectInvalidUrlDrillParameterWidgetWarnings = toolkit_1.createSelector(selectInvalidCustomUrlDrillParameterWidgets, function (invalidCustomUrlDrillParameterWidgets) {
    return invalidCustomUrlDrillParameterWidgets.filter(function (item) { return item.showMessage; }).map(function (i) { return i.widgetRef; });
});
var selectInvalidUrlDrillParameterWidgetsMap = toolkit_1.createSelector(selectInvalidCustomUrlDrillParameterWidgets, function (invalidCustomUrlDrillParameterWidgets) {
    return new objRefMap_1.ObjRefMap({
        idExtract: function (i) { return i.widgetId; },
        refExtract: function (i) { return i.widgetRef; },
        uriExtract: function (i) { return i.widgetUri; },
        strictTypeCheck: false,
    }).fromItems(invalidCustomUrlDrillParameterWidgets);
});
/**
 * @internal
 */
exports.selectInvalidUrlDrillParameterDrillLocalIdsByWidgetRef = selectors_1.createMemoizedSelector(function (ref) {
    return toolkit_1.createSelector(selectInvalidUrlDrillParameterWidgetsMap, function (invalidParameterWidgetsMap) { var _a, _b; return (_b = (_a = invalidParameterWidgetsMap.get(ref)) === null || _a === void 0 ? void 0 : _a.drillsWithInvalidParametersLocalIds) !== null && _b !== void 0 ? _b : []; });
});
/**
 * @internal
 */
exports.selectDraggingWidgetSource = toolkit_1.createSelector(selectSelf, function (state) { return state.draggingWidgetSource; });
/**
 * @internal
 */
exports.selectDraggingWidgetTarget = toolkit_1.createSelector(selectSelf, function (state) { return state.draggingWidgetTarget; });
/**
 * @internal
 */
exports.selectWidgetsOverlay = toolkit_1.createSelector(selectSelf, function (state) { return state.widgetsOverlay; });
/**
 * @internal
 */
exports.selectWidgetsOverlayState = selectors_1.createMemoizedSelector(function (refs) {
    return toolkit_1.createSelector(exports.selectWidgetsOverlay, function (overlay) {
        return refs.every(function (ref) {
            var _a, _b;
            return (_b = (ref && ((_a = overlay[sdk_model_1.objRefToString(ref)]) === null || _a === void 0 ? void 0 : _a.showOverlay))) !== null && _b !== void 0 ? _b : false;
        });
    });
});
/**
 * @internal
 */
exports.selectWidgetsModification = selectors_1.createMemoizedSelector(function (refs) {
    return toolkit_1.createSelector(exports.selectWidgetsOverlay, function (overlay) {
        return refs.reduce(function (modification, ref) {
            var item = ref && overlay[sdk_model_1.objRefToString(ref)];
            if (item === null || item === void 0 ? void 0 : item.modification) {
                return union_1.default(modification, [item.modification]);
            }
            return modification;
        }, []);
    });
});
/**
 * @internal
 */
exports.selectSectionModification = selectors_1.createMemoizedSelector(function (refs) {
    return toolkit_1.createSelector(exports.selectWidgetsOverlay, function (overlay) {
        var modifications = refs.map(function (ref) {
            var item = ref && overlay[sdk_model_1.objRefToString(ref)];
            return item === null || item === void 0 ? void 0 : item.modification;
        });
        var inserted = filter_1.default(modifications, function (a) { return a === "insertedByPlugin"; });
        var modified = filter_1.default(modifications, function (a) { return a === "modifiedByPlugin"; });
        return tslib_1.__spread((inserted.length === refs.length ? ["insertedByPlugin"] : []), (modified.length === refs.length ? ["modifiedByPlugin"] : []));
    });
});
/**
 * @internal
 */
exports.selectIsSectionInsertedByPlugin = selectors_1.createMemoizedSelector(function (refs) {
    return toolkit_1.createSelector(exports.selectSectionModification(refs), 
    // When all the widgets in the section were inserted by the plugin,
    // the section was added by the plugin as well (empty section(s) cannot be added)
    function (modifications) { return modifications.length > 0 && modifications.every(function (m) { return m === "insertedByPlugin"; }); });
});
//# sourceMappingURL=uiSelectors.js.map